
import { Vue, Options, prop } from "vue-class-component";
import { OptionsClass } from "@/domain/entities/MainApp";
import Icons from "@/app/ui/components/icons/index.vue";
import LastLocationFilterSection, {
  LastLocationOptionValue,
} from "../shared/last-location-filter-section.vue";

class Props {
  productType = prop<OptionsClass>({
    default: () => new OptionsClass()
  });

  productTypeOptions = prop<OptionsClass[]>({
    default: () => []
  });

  startDate = prop<Date | null>({
    default: null
  });

  endDate = prop<Date | null>({
    default: null
  });

  options = prop<{ name: string; value: { cityCode: string; hubId: number } }[]>({
    default: () => [],
  });
}

@Options({
  components: { LastLocationFilterSection },
  emits: ["apply", "reset"],
})
export default class FilterSectionPod extends Vue.with(Props) {
  isOpen = false;
  filterProductType: OptionsClass = new OptionsClass();
  filterStartDate: Date | null = new Date(
    new Date(new Date().setDate(new Date().getDate() - 1))
  );
  filterEndDate: Date | null = new Date() as Date | null;
  selectedLastLocations: LastLocationOptionValue[] = [];
  lastLocationRef: any = null;

  syncFromProps() {
    this.filterProductType = this.productType;
    this.filterStartDate = this.startDate;
    this.filterEndDate = this.endDate;
  }

  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.syncFromProps();
    }
  }

  onProductTypeChange(value: OptionsClass) {
    this.filterProductType = value;
  }

  onPeriodeChange(value: Array<Date | null>) {
    this.filterStartDate = value[0];
    this.filterEndDate = value[1];
  }

  onApply() {
    this.isOpen = false;

    this.$emit("apply", {
      productType: this.filterProductType,
      startDate: this.filterStartDate,
      endDate: this.filterEndDate,
      lastLocations: {
        cityCodes: this.selectedLastLocations.map((s) => s.cityCode),
        hubIds: this.selectedLastLocations.map((s) => s.hubId),
      },
    });
  }

  onReset() {
    this.filterProductType = new OptionsClass();
    this.filterStartDate = null;
    this.filterEndDate = null;
    this.selectedLastLocations = [];
    this.lastLocationRef?.reset();

    this.$emit("reset");
    this.isOpen = false;
  }

  get activeFilterCount(): number {
    let count = 0;
    if (this.filterProductType && this.filterProductType.value) {
      count++;
    }

    if (this.filterStartDate !== null || this.filterEndDate !== null) {
      count++;
    }

    if (this.selectedLastLocations.length) {
      count++;
    }

    return count;
  }

  get isApplyDisabled(): boolean {
    const hasProductType =
      !!this.filterProductType && !!this.filterProductType.value;

    const hasDate =
      this.filterStartDate !== null || this.filterEndDate !== null;

    const hasLastLocation =
      this.selectedLastLocations.length

    return !hasProductType && !hasDate && !hasLastLocation;
  }
}
